<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1"
            >
              <label>{{ $t('DEBTIA_SHOWING') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                class="search_by_select per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <b-col
              cols="12"
              md="4"
              offset-md="2"
              class="query-input"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('DEBTIA_SEARCH')"
                />

                <b-button
                  v-if="$ability.can(constants.action.permissionAddCustomVar, constants.resource.customVariables) && !isSuperAdmin"
                  id="add-case-btn"
                  v-b-modal.modal-add-customfields
                  variant="primary"
                  @click="$refs['modal-add-customfields'].resetModal()"
                >
                  <span class="text-nowrap">{{ 'Add Custom Field' }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refUserListTable"
          class="position-relative"
          responsive
          :fields="tableFields"
          :items="casesData"
          hover
        >
          <template #cell(action)="data">
            <feather-icon
              v-if="!isSuperAdmin && $ability.can(constants.action.permissionDeleteCustomVar, constants.resource.customVariables)"
              icon="Trash2Icon"
              style="margin-left: 15px; color: #ff3737;"
              @click="confirmation(data.item.id)"
            />
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOWING') }} {{ from }} to {{ to }} of {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
        <add-custom-field
          ref="modal-add-customfields"
          :get-custom-fields="getCustomFields"
        />
        <!-- <case-details
          :case-id="caseId"
          :modal-loads="modalLoader"
          :reload-method="getCases"
          :show="!modalLoader"
          :case-busy="busy"
        /> -->
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BButton, BPagination,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import Ripple from 'vue-ripple-directive'
import AddCustomField from './AddCustomField.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BButton,
    BPagination,
    AddCustomField,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loader: false,
      casesData: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      modalLoader: true,
      constants,
      isSuperAdmin: false,
    }
  },
  computed: {
    tableFields() {
      return [
        { key: 'id', sortable: true },
        { key: 'variable', sortable: true, label: i18n.t('DEBTIA_VARIABLE') },
        { key: 'var_type', sortable: true, label: i18n.t('DEBTIA_TYPE') },
        { key: 'var_for', label: i18n.t('DEBTIA_VARIABLE_FOR') },
        { key: 'action', label: i18n.t('DEBTIA_ACTION') },
      ]
    },
  },
  watch: {
    searchQuery: {
      handler() {
        this.getCustomFields()
      },
    },
    currentPage: {
      handler() {
        this.getCustomFields()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getCustomFields()
      },
    },
    caseGroupValue: {
      handler() {
        this.currentPage = 1
        this.getCustomFields()
      },
    },
  },
  created() {
    this.actionColumn()
    this.getCustomFields()
  },
  methods: {
    confirmation(id) {
      // methodId
      this.$swal({
        title: 'CAUTION',
        text: 'Are you sure to delete this custom field as you wont be able to revert it',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.deleteCustomField(id, false)
        }
      })
    },
    async deleteCustomField(id, deleteVar) {
      this.loader = true
      let alertMsg = true
      const varDeleted = await axios.post('/settings/delete-custom-variables', { id, delete: deleteVar })
      if (varDeleted.status) {
        if (varDeleted.data.data.exists) {
          alertMsg = false
          this.$swal({
            title: 'CAUTION',
            text: varDeleted.data.message,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
            },
            buttonsStyling: false,
          }).then(result => {
            if (result.value) {
              this.deleteCustomField(id, true)
            }
          })
        }
        if (alertMsg) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Success',
              icon: 'CoffeeIcon',
              variant: 'success',
              text: 'Custom Field deleted successfully.',
            },
          })
        }
        this.getCustomFields()
      }
    },
    searchRecords() {
      if (this.searchQuery.length > 0) {
        this.searchRun = true
        this.getCases()
      }
    },
    async getCustomFields() {
      try {
        if (this.user_type === 'super-admin' || this.user_type === 'system-user') {
          this.isSuperAdmin = true
        } else {
          this.isSuperAdmin = false
        }
        this.loader = true
        const cases = await axios.get(`/settings/list-custom-variables?perPage=${this.perPage}&q=${this.searchQuery}&page=${this.currentPage}&sortDesc=true`)
        // this.loader = false
        if (cases.status) {
          // console.log('cases', cases)
          this.casesData = cases.data.data.data
          // console.log('casesData', this.casesData)
          this.totalPages = cases.data.data.total
          this.from = cases.data.data.from
          this.to = cases.data.data.to
          this.currentPage = cases.data.data.current_page
          this.loader = false
          // console.log('refs are ', this.$refs)
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    actionColumn() {
      if (this.$ability.cannot(this.constants.action.permissionDeleteCustomVar, this.constants.resource.customVariables) && this.$ability.cannot(this.constants.action.permissionLetterTemplateDelete, this.constants.resource.letterTemplate)) {
        this.tableFields.splice(4)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.search_by_select .vs__dropdown-toggle{
  width: 160px;
}

.casegroups .vs__dropdown-toggle{
  width: 200px;
}

.form-group label {
  font-size: 1rem;
}
</style>
